<script>
export default {
    name: 'RedirecionaPlanoExpirado',
    async created() {
        window.location.assign(`${window.location.origin}${window.location.pathname}plano-expirado.html`)
    }
}
</script>
